export const getNestedError = (err?: unknown): string | null => {
  if (!err) {
    return null
  }
  const isArray = Array.isArray(err)

  const isString = typeof err === 'string'
  const isObject = typeof err === 'object'

  if (isArray) {
    const errorItem = err.find((errItem) => !!getNestedError(errItem))
    return getNestedError(errorItem)
  }
  if (isObject) {
    return getNestedError(Object.values(err || {}))
  }
  if (isString) {
    return err
  }

  return null
}

export const extractErrorMessages = (data: Record<string, unknown> | string, path = ''): string[] => {
  const messages: string[] = []

  if (typeof data === 'string') {
    messages.push(`${path ? path + ': ' : ''}${data}`)
  } else if (Array.isArray(data)) {
    data.forEach((item, index) => {
      messages.push(...extractErrorMessages(item, `${path}[${index}]`))
    })
  } else if (typeof data === 'object' && data !== null) {
    for (const key in data) {
      messages.push(...extractErrorMessages(data[key] as Record<string, unknown>, path ? `${path}.${key}` : key))
    }
  }

  return messages
}
